// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Tab_wrap__t7yl9","active":"Tab_active__DOvmk"};